"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _theme = _interopRequireDefault(require("./theme"));

var _pickers = require("@material-ui/pickers");

var _moment = _interopRequireDefault(require("@date-io/moment"));

var _moment2 = _interopRequireDefault(require("moment"));

require("moment/locale/nb");

require("moment/locale/nn");

require("moment/locale/sv");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

_moment2.default.locale("nb"); // it is required to select default locale manually


const DateInput = ({
  id = "date-input",
  label = "Date",
  value = undefined,
  helperText,
  inputFormat = "DD.MM.YYYY",
  format = "YYYY-DD-MM",
  onChange
}) => {
  const _useState = (0, _react.useState)(value || new Date()),
        selectedDate = _useState[0],
        setSelectedDate = _useState[1];

  const handleChange = date => {
    setSelectedDate(date);
    const formattedDate = (0, _moment2.default)(date).format(format);
    onChange && onChange(formattedDate, date);
  };

  return _react.default.createElement(_styles.ThemeProvider, {
    theme: _theme.default
  }, _react.default.createElement(_pickers.MuiPickersUtilsProvider, {
    utils: _moment.default
  }, _react.default.createElement(_pickers.KeyboardDatePicker, {
    disableToolbar: true,
    variant: "inline",
    id: id,
    label: label,
    value: selectedDate,
    helperText: helperText,
    inputVariant: "filled",
    format: inputFormat,
    onChange: handleChange,
    PopoverProps: {
      anchorOrigin: {
        "vertical": 'bottom',
        "horizontal": 'left'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'left'
      }
    },
    KeyboardButtonProps: {
      'aria-label': 'change date'
    }
  })));
};

var _default = DateInput;
exports.default = _default;
module.exports = exports.default;